import { render, staticRenderFns } from "./Compact-Page.vue?vue&type=template&id=5d40f4d1&"
import script from "./Compact-Page.vue?vue&type=script&lang=js&"
export * from "./Compact-Page.vue?vue&type=script&lang=js&"
import style0 from "./Compact-Page.vue?vue&type=style&index=0&id=5d40f4d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports